import { createFileRoute } from '@tanstack/react-router';
import { CmsBlocksListPage } from '@pages/website';

/** CMS Block-Liste für eine Section (/website/$pageId/$sectionId) */
export const Route = createFileRoute('/_authenticated/website/$pageId/$sectionId')({
  component: function CmsBlocksRoute() {
    const { pageId, sectionId } = Route.useParams();
    return <CmsBlocksListPage pageId={pageId} sectionId={sectionId} />;
  },
});
